import {DefaultNavLinkProps} from '@models/DefaultProps.ts';
import React from "react";
import {SxProps, TypographyProps} from "@mui/material";
import {PermissaoAplicacao} from "@models/seguranca/permissaoApp.ts";
import {NavButton, NavButtonProps} from "@shared/custom/NavButton.tsx";

export interface NavigationLinkProps extends DefaultNavLinkProps {
	pathName: string,
	searchData: object,
	ignoreNavigate?: boolean,
	hash?: string,
	label?: string,
	typographyProps?: Partial<TypographyProps>,
	toolTipHint?: string,
	permissoesNecessarias?: PermissaoAplicacao[],
	chipSx?: SxProps,
	tableMode?: boolean,
	onClick?: () => void;
	onContextMenu?: (e: React.MouseEvent<HTMLElement>) => void;
}

/**
 * @deprecated use {@link NavButton}
 * @param props
 * @constructor
 */
export function NavigationLink(props: NavigationLinkProps) {
	const {
		pathName,
		label,
		toolTipHint,
		chipSx,
		...p
	} = props;

	const btnProps: NavButtonProps = {
		...p,
		pathname: pathName,
		label: () => label ?? '',
		hint: toolTipHint,
		slotProps: {
			...p.slotProps,
			chip: {
				...p.slotProps?.chip,
				sx: {
					...p.slotProps?.chip?.sx,
					...chipSx
				}
			}
		}
	} as any

	return <NavButton {...btnProps} />
}
